import {DATA_TYPE} from '@constants/data-type.constant';
import {GatewayValues} from '@models/adminstration/gateway/gateway-configuration/gateway-values';

export class GatewayArray{
  name: string = '';
  datatype: DATA_TYPE | string = '';
  values: GatewayValues[] = [];
}